import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { useRafThrottledAtomValue } from '@flipster/react/misc/state/use-throttled-atom-value';
import { css } from '@flipster/styled-system/css';
import { Price } from '@flipster/ui';
import { getQuoteCurrencyPrecision } from '@flipster/utils/constants/currency';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { formBunja } from './bunja/form';
import { realtimeStateBunja } from './bunja/price';
import { col, info, row } from './styles';

const OrderTypeInfo = () => {
  const transAssets = useTranslations('Assets.r250401');
  const { symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);
  const { orderStateAtom } = useBunja(formBunja);
  const { askMarginAtom, bidMarginAtom, askQuantityAtom, bidQuantityAtom } = useBunja(realtimeStateBunja);
  const orderState = useAtomValue(orderStateAtom);
  const throttledAskMargin = useRafThrottledAtomValue(askMarginAtom);
  const throttledBidMargin = useRafThrottledAtomValue(bidMarginAtom);
  const throttledAskQuantity = useRafThrottledAtomValue(askQuantityAtom);
  const throttledBidQuantity = useRafThrottledAtomValue(bidQuantityAtom);

  if (!symbolInfo) return null;

  const currency = symbolInfo.positionUnit;
  const quoteCurrency = symbolInfo.quoteCurrency;
  const tradeQtyPrecision = symbolInfo.tradeQtyPrecision;
  const quoteCurrencyPrecision = getQuoteCurrencyPrecision(quoteCurrency);

  if (orderState.kind === 'margin')
    return (
      <div className={info}>
        <p className={label}>{transAssets('Quantity')}</p>
        <div className={row}>
          <div className={col}>
            <Price
              fontType='num3'
              price={throttledAskQuantity}
              currency={currency}
              withColor
              priceColor='green'
              precision={tradeQtyPrecision}
              toFixed
            />
          </div>
          <div className={col}>
            <Price
              fontType='num3'
              price={throttledBidQuantity}
              currency={currency}
              withColor
              priceColor='red'
              precision={tradeQtyPrecision}
              toFixed
            />
          </div>
        </div>
      </div>
    );

  return (
    <div className={info}>
      <p className={label}>
        <FormattedMessage id='Autogen_common.r251126.s_Margin' />
      </p>
      <div className={row}>
        <div className={col}>
          <Price
            fontType='num3'
            price={throttledAskMargin}
            currency={quoteCurrency}
            precision={quoteCurrencyPrecision}
            toFixed
            withColor
            priceColor='green'
          />
        </div>
        <div className={col}>
          <Price
            fontType='num3'
            price={throttledBidMargin}
            currency={quoteCurrency}
            precision={quoteCurrencyPrecision}
            toFixed
            withColor
            priceColor='red'
          />
        </div>
      </div>
    </div>
  );
};

export default OrderTypeInfo;

const label = css({
  textStyle: 'Text/M/Strong',
  mb: 4,
  color: 'content.default.level-2',
});
